import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareKnowledgeRoute: InvariantJiraRoute = {
	name: 'software-knowledge',
	exact: true,
	path: '/jira/software/projects/:projectKey/knowledge',
};
